import Vue from "vue";
import Vuex from "vuex";
import permission from './modules/permission'
import user from './modules/user'
import getters from './getters'
import paramConfig from "@/store/modules/paramConfig";
import role from "@/store/modules/role";
import supplier from "@/store/modules/supplier";
import nxtele from "@/store/modules/nxtele";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
      permission,
      user,
      role,
      supplier,
      nxtele,
      paramConfig
  },
  getters
});
